import { merge } from 'lodash';
import { NodeModel } from 'storm-react-diagrams';

export class ActivityNodeModel extends NodeModel {
  constructor(data, id, isChapter) {
    super('activity', id);
    this.setActivityNodeData = this.setActivityNodeData.bind(this);
    this.activityNodeData = data;
    this.setBlockData = this.setBlockData.bind(this);
    this.reattemptData = data.reattemptData ? data.reattemptData : [[]];
    this.completionData = data.completionData ? data.completionData : [[]];
    this.selectedExternally = false;
    this.editable = id ? false : true;
    this.isChapter = isChapter;
  }

  setBlockData(blockData) {
    this.activityNodeData['block'] = blockData;
  }

  setTagData(tagData) {
    this.activityNodeData['tags'].push(tagData);
  }

  setActivityNodeData(newActivityNodeData) {
    this.activityNodeData.id = this.id;
    this.activityNodeData = newActivityNodeData;
  }

  serialize() {
    return merge(super.serialize(), {
      activityNodeData: this.activityNodeData,
      reattemptData: this.reattemptData,
      completionData: this.completionData,
      editable: this.editable,
    });
  }
}
